import { useAccommodationPlacesByCoupleQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';

export const useAccommodationPlacesByCouple = () => {
  const { eventHandle } = useEventInfo();
  const { data, loading, error } = useAccommodationPlacesByCoupleQuery({
    variables: {
      name: eventHandle || ''
    },
    batchMode: 'fast'
  });

  return {
    accommodationPlaces: data?.eventByName?.accommodationPlacesV2 || [],
    loading,
    error
  };
};
